import React from 'react';
import { useTranslation } from 'react-i18next';

import { convertKeysToCamelCase } from '../helpers/baseHelper';
import style from '../assets/scss/components/LogoutModal.module.scss';
import Modal from './Modal';

function ProfileDestroyModal(props) {
  const { isModalOpen, handleClose, handleProfileDestroy } = props;
  const { t } = useTranslation();
  const { wrapper, buttonsWrapper } = convertKeysToCamelCase(style);

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={handleClose}
      content={
        <div className={wrapper}>
          <h3>{t('profile.destroy.modal.title')}</h3>
          <div className={buttonsWrapper}>
            <button onClick={handleProfileDestroy} className="secondary-red">
              {t('logout.modal.yes')}
            </button>
            <button onClick={handleClose}>{t('logout.modal.no')}</button>
          </div>
        </div>
      }
    />
  );
}

export default ProfileDestroyModal;
